import { FinancialSummary } from '../../../../../../clients/quipli-service/financials/financials';
import { Invoice } from '../../../../../../clients/quipli-service/invoice/invoice';
import { Order } from '../../../../../../clients/quipli-service/order/order';
import { InventoryReturnRequest } from '../../../../../../clients/quipli-service/order/order';
import { InventoryReturnCalculationsResult } from '../../../../../order/status-transitions/inventory-return';
import { PaymentMethodRequestV2 } from '../../../../../../clients/quipli-service/payment/payment-v2';
import { Payment } from '../../../../../../clients/quipli-service/payment/payment';
import { Toggle } from '../../../../../../components/form/toggle';
import { StatusTransitionPayment } from '../../../status-transition-payment';

export const OffRentPaymentSection = ({
  existingSummary,
  lateChargeSummary,
  invoice,
  balance,
  setOffRentWithPayment,
  offRentWithPayment,
  order,
  inventoryReturnRequest,
  cycleBillingReturnTotals,
  paymentsTotal,
  amount,
  setAmount,
  paymentMethod,
  setPaymentMethod,
  total,
  payments,
  setPayments,
  facilitate,
  postPayment,
}: {
  existingSummary: FinancialSummary | undefined;
  lateChargeSummary: FinancialSummary | undefined;
  invoice: Invoice | undefined;
  balance: Dinero.Dinero;
  setOffRentWithPayment: React.Dispatch<React.SetStateAction<boolean>>;
  offRentWithPayment: boolean;
  order: Order;
  inventoryReturnRequest: InventoryReturnRequest | undefined;
  cycleBillingReturnTotals: InventoryReturnCalculationsResult;
  paymentsTotal: Dinero.Dinero;
  amount: string | undefined;
  setAmount: React.Dispatch<React.SetStateAction<string | undefined>>;
  paymentMethod: PaymentMethodRequestV2 | undefined;
  setPaymentMethod: React.Dispatch<React.SetStateAction<PaymentMethodRequestV2 | undefined>>;
  total: Dinero.Dinero | undefined;
  payments: Payment[] | undefined;
  setPayments: React.Dispatch<React.SetStateAction<Payment[] | undefined>>;
  facilitate: boolean;
  postPayment: (payments?: Payment[]) => void;
}) => {
  return (
    <>
      {(existingSummary && lateChargeSummary && lateChargeSummary.total.greaterThan(existingSummary.total)) ||
      (invoice && balance.toUnit() > 0) ? (
        <div className="mt-4 flex flex-column gap-2">
          <h6 className="m-0">Payment</h6>
          <div className="flex gap-2 text-[0.9rem]">
            <Toggle
              onClick={() => {
                setOffRentWithPayment((prev) => !prev);
              }}
              checked={offRentWithPayment}
            />
            Off Rent with Payment
          </div>
          {offRentWithPayment && (
            <StatusTransitionPayment
              order={order}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              total={
                (order.isCycleBilled && inventoryReturnRequest
                  ? cycleBillingReturnTotals.total.toUnit()
                  : total?.toUnit()) || 0
              }
              paymentTotal={paymentsTotal.toUnit()}
              amount={amount}
              setAmount={setAmount}
              defaultPercentage={100}
              payments={payments}
              setPayments={setPayments}
              facilitate={facilitate}
              onComplete={postPayment}
            />
          )}
        </div>
      ) : (
        !order.isCycleBilled && <div className="mt-4">Order has been fully paid</div>
      )}
    </>
  );
};
